import React, { useCallback, useState, useEffect } from 'react';
import Link from 'next/link';
import cookie from 'react-cookies';
import { captureException } from '@sentry/node';
import { dataLayerPush } from '@stelecom/ui-react/components/helpers';
import { IClientPersonal } from '~/src/store/reducers/auth';
import { RightCollapsedMenu } from '~/src/components/Header/RightCollapsedMenu';
import { ACTIONS, CATEGORIES, EVENTS } from '~/src/constants/analytics';
import PopupNoAuth from '~/src/components/Popups/NoAuth';
import TariffAPI from '~/src/api/tariffDetail';
import { getClientId } from '~/src/helpers/clientInfo';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';
import { ICurrentCity } from '~/src/store/reducers/city';
import PopupResponse, { IPopupResponseProps } from '~/src/components/Header/PopupResponse';
import { IMenuItem } from '~/src/api/content/menu';
import { ImgWrapper, Login, Name } from '../RightMenu/styled';
// @ts-ignore
import geo from '~/static/images/header/geo.svg';
import * as ST from './styled';

export const LK_HREF = '/user/login';

export const ERROR = 'error';
export const SUCCESS = 'success';
export const ZERO = 0;

interface IBecomeClientData {
  phone: string;
  name: string;
}

interface IProps {
  isAuth: boolean;
  menuItems: IMenuItem[];
  productsInfo: {
    productId: number;
  }[];
  clientInfo: IClientPersonal | null;
  logout: () => void;
  closeHandler?: () => void;
  openCitySelect: () => void;
  enableBecomeClientPopup: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isFixed: boolean;
  isVisibility: boolean;
  city: ICurrentCity;
  onClick: (item: string, menuType?: string) => void;
  onHover: (item: string, menuType?: string) => void;
  modalShow:boolean;
  changeStateModalWindow: () => void;
}

interface IRequestByConnectionData {
  request_id: number;
  message: string;
  billing_code: number;
}

const Profile = ({
  isAuth,
  clientInfo,
  logout,
  productsInfo,
  closeHandler,
  city,
  isTablet,
  openCitySelect,
  modalShow,
  changeStateModalWindow
}: IProps): JSX.Element => {
  const [showBecomeClientPopup, setShowBecomeClientPopup] = useState(false);
  const [becomeClientResponseStatus, setBecomeClientResponseStatus] = useState<IPopupResponseProps['type']>();
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [referrerPath, setReferrerPath] = useState('');

  useEffect(() => {
    if (window) {
      setReferrerPath(`?referrer=${location.pathname}&forceRedirect=true`);
    }
  }, []);

  const sendAuthEvent = useCallback(
    (action = 'Войти в личный кабинет') => {
      dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.mainMenuClick,
        action,
        label: 'menu_new',
      });
      closeHandler && closeHandler();
    },
    [closeHandler]
  );

  const sendBecomeClient = useCallback(
    async(data: IBecomeClientData) => {
      const { domain, cityId } = city;
      const clientId = cookie.load('_ga_cid');
      setIsLoading(true);
      try {
        const requestByConnectionData: IRequestByConnectionData =
          await TariffAPI.postData(
            {
              fio: data.name,
              phone: data.phone,
              ga_cid: clientId ? clientId : getClientId(),
              city_id: cityId,
              domain,
            },
            domain
          );
        if (!requestByConnectionData.request_id) {
          dataLayerForCBPhonePush({
            action: ACTIONS.error,
            isPopup: true,
            requestId: null,
          });
        } else {
          dataLayerForCBPhonePush({
            action: ACTIONS.finished,
            requestId: requestByConnectionData.request_id,
            isPopup: true,
          });
        }
        setBecomeClientResponseStatus('success');
      } catch (e) {
        setBecomeClientResponseStatus('error');
        dataLayerForCBPhonePush({
          action: ACTIONS.error,
          isPopup: true,
          requestId: null,
        });
        captureException(e);
      } finally {
        setIsLoading(false);
        setShowResponsePopup(true);
        setShowBecomeClientPopup(false);
      }
    },
    [city]
  );

  const openBecomeClientPopup = useCallback(() => {
    // sendAuthEvent('Стать клиентом');
    setShowBecomeClientPopup(true);
    // closeHandler && closeHandler();
  }, []);


  useEffect(() => {
    if (modalShow) {
      openBecomeClientPopup();
    }
  }, [modalShow]);

  return (
    <>
      <ST.MainMenuWrap>
        <ST.MainMenuPayment>
          <Link href={'/payments'} prefetch={false}>
            <p>Оплатить</p>
          </Link>
        </ST.MainMenuPayment>
      </ST.MainMenuWrap>
      <ST.CityWrapper>
        <ImgWrapper>
          <img src={geo} alt='' />
        </ImgWrapper>
        <ST.CitySelect onClick={openCitySelect} data-test='city-select-btn'>
          {city ? city.name : null}
        </ST.CitySelect>
      </ST.CityWrapper>
      {!isAuth
? (
        isTablet && (
          <ST.LoginWrapper>
            <Link href={LK_HREF + referrerPath} passHref>
              <ST.Profile
                onClick={() => sendAuthEvent('Войти в личный кабинет')}
              >
                <Login data-test='lk-login'>Войти в личный кабинет</Login>
              </ST.Profile>
            </Link>
          </ST.LoginWrapper>
        )
      )
: (
        <ST.ProfileAuthWrapper>
          <ST.ProfileAuth>
            {clientInfo && isTablet && (
              <Name data-test='lk-fio' content={clientInfo.fio[ZERO]}>
                Личный кабинет
              </Name>
            )}
            {isTablet && (
              <RightCollapsedMenu productsInfo={productsInfo} logout={logout} />
            )}
          </ST.ProfileAuth>
        </ST.ProfileAuthWrapper>
      )}
      {showBecomeClientPopup && (
        <PopupNoAuth
          title={'Заявка на подключение'}
          open={showBecomeClientPopup}
          close={() => {
                          setShowBecomeClientPopup(false);
                          changeStateModalWindow();
                       }
          }
          handleSuccess={sendBecomeClient}
          onlyBecomeClient={true}
          disableButton={isLoading}
        />
      )}

      <PopupResponse
        isOpen={showResponsePopup}
        type={becomeClientResponseStatus}
        onClose={() => setShowResponsePopup(false)}
        message={
          becomeClientResponseStatus === 'success'
            ? 'Заявка успешно отправлена!'
            : 'Что-то пошло не так!'
        }
        description={
          becomeClientResponseStatus === 'success'
            ? 'В ближайшее время мы с вами свяжемся'
            : (
                <>
                  Свяжитесь с нами по номеру {' '}
                  <ST.Link href='tel:8(495)1488555'>8 (495) 148 8 555</ST.Link>
                </>
              )
        }
      />
    </>
  );
};

export default Profile;
